export default __webpack_public_path__ + "static/media/7.dabab0c2.jpg";